import React from "react"
import { Navigate } from "react-router-dom"
import { lazy } from "react"

// Super Admin
import SLogin from "../pages/SuperAdmin/Auth/Login"

import SuperDashboard from "../pages/SuperAdmin/Users/Users"
import SuperAdminEmployees from "../pages/SuperAdmin/Users/Employee"

import SuperAdminUserPlan from "../pages/SuperAdmin/Users/AllUser"
import SuperAdminViewSubcription from "../pages/SuperAdmin/Users/UserSubscription"

import SuperAdminHome from "../pages/SuperAdmin/LOB/Home"
import SuperAdminSubLobHome from "../pages/SuperAdmin/SubLOB/Home"
import SuperAdminInsuranceHome from "../pages/SuperAdmin/InsuranceCompany/Home"
import SuperAdminCounts from "../pages/SuperAdmin/Users/CountUser"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

//SUPER ADMIN
import ManageKnowledgeCenter from "pages/SuperAdmin/KnowledgeCenter"
import VehicleMasterAdmin from "pages/SuperAdmin/VehicleMaster"
import MangageRTOAdmin from "pages/SuperAdmin/ManageRTO"
import ManageIncomerRange from "pages/SuperAdmin/ManageIncomeRange"
import ManageMarketingTools from "pages/SuperAdmin/MarketingTools"
import CreateDesigns from "pages/SuperAdmin/MarketingTools/CreateDesigns"
import SuperAdminNdaAgreement from "pages/SuperAdmin/NdaAgreement"
import SendWhatsAppMsg from "pages/SuperAdmin/SendWhatsAppMsg"
import RenewalTrigger from "pages/RenewalTracking/Triggers/RenewalTrigger"
import CompanyKnowledgeGuide from "pages/CompanyKnowledgeGuide"
import LeadsBulkUpload from "pages/Leads/LeadsBulkUpload"
import CustBulkUpload from "pages/Customer/CustBulkUpload"
import PolicyBulkUpload from "pages/Polices/PolicyBulkUpload"
import MutualFundBulkUpload from "pages/MutualFund/MutualFundBulkUpload"
import References from "pages/References"
import CustCreateClaim from "pages/ClaimForm/CustCreateClaim"
import SelectDesigns from "pages/MarketingTool.js/SelectDesigns"
import BlockedCustomer from "pages/Customer/BlockedCustomer"
import QueryFile from "pages/SuperAdmin/QueryFiles"
import RefFiles from "pages/References/FileUploads/RefFiles"
import TermsOfUse from "pages/Legal/TermsOfUse"
import PrivacyPolicy from "pages/Legal/PrivacyPolicy/PrivacyPolicy"
import CancellationAndRefund from "pages/Legal/CancellationAndRefund"
import ExcelReports from "pages/Polices/Reports/ExcelReports"

//Profile
const UserProfile = lazy(() =>
  import("../pages/Authentication/Profile/user-profile")
)

//Notifications

const Notification = lazy(() => import("../pages/Notification/Notification"))
const RenewalTracking = lazy(() => import("../pages/RenewalTracking/Dashboard"))
const HomeUpgradePlan = lazy(() => import("../pages/SubscriptionPlan/Pricing"))
const PremiumPlan = lazy(() => import("../pages/SubscriptionPlan/Premium"))

// Dashboard
const Dashboard = lazy(() => import("../pages/Dashboard/Home"))
const DashboardReports = lazy(() => import("../pages/Dashboard/index"))

const PaymentFailure = lazy(() =>
  import("../pages/SubscriptionPlan/PaymentFail")
)
const PaymentSuccess = lazy(() =>
  import("../pages/SubscriptionPlan/PaymentSuccess")
)

const SocialMedia = lazy(() =>
  import("../pages/Authentication/Profile/SocialMedia")
)
const Employee = lazy(() => import("pages/Employee"))
const EmpProfile = lazy(() => import("pages/Employee/Profile/user-profile"))
const FormWizard = lazy(() =>
  import("../pages/Authentication/Profile/FormWizard")
)
const LeadsManagement = lazy(() => import("../pages/Leads/index"))
const CustomerManagement = lazy(() => import("pages/Customer"))
const CustomerMutualFund = lazy(() => import("pages/MutualFund/CustomerMutualFund"))
const ViewMutualFund = lazy(() => import("pages/MutualFund/ViewMutualFund"))
const EditMutualFund = lazy(() => import("pages/MutualFund/EditMutualFund"));
const MutualFundReports = lazy(() => import("pages/MutualFund/MutualFundReports"))
const VerifyEmployee = lazy(() => import("pages/Employee/VerifyEmployee"))
const SingleCustomer = lazy(() => import("pages/Customer/SingleCustomer"))
const ViewLeads = lazy(() => import("pages/Leads/ViewLeads"))
const BlockedLeads = lazy(() => import("pages/Leads/BlockLead"))
// Access page
const Access = lazy(() => import("pages/Authentication/Access/Access"))
const AddProfile = lazy(() => import("pages/Authentication/Access/AddProfile"))
const AssignProfile = lazy(() =>
  import("pages/Authentication/Access/AssignProfile")
)

// View-Employee
const ViewEmployee = lazy(() => import("pages/Employee/ViewEmployee"))

const Pricing = lazy(() => import("pages/SubscriptionPlan/Pricing"))
// Policies
const PolicesDash = lazy(() => import("pages/Polices/Dashboard"))
const ViewPolicy = lazy(() => import("pages/Polices/ViewPolicy"))

// Cross-sell
const CrossSellHome = lazy(() => import("pages/Cross-sell/Home"))

// Up-Sell
const UpSellHome = lazy(() => import("pages/Up-sell/Home"))

// Claims
const CustomFieldForm = lazy(() =>
  import("pages/Leads/CustomFields/CustomFieldForm")
)
const CustomerCustomField = lazy(() =>
  import("pages/Customer/CustomFields/CustomFieldForm")
)

// Report
const Claim = lazy(() => import("pages/ClaimForm/Claims"))
const CalculateInsuranceNeed = lazy(() =>
  import("pages/InsuranceNeed/CalculateInsuranceNeed")
)
const InsuranceNeedModal = lazy(() =>
  import("pages/InsuranceNeed/InsuranceNeedModal")
)
const SearchCustomer = lazy(() => import("pages/Customer/SearchCustomer/index"))
const PolicyReportes = lazy(() => import("pages/Polices/Reports/Home"))
const Home = lazy(() => import("pages/Target/Home"))
const TargetDash = lazy(() => import("pages/Target/Dashboard/Home"))

// Marketing Tools

const MarketingTools = lazy(() => import("pages/MarketingTool.js/Tool"))
const SavedDesign = lazy(() => import("pages/MarketingTool.js/SavedDesign"))
const TermsAndCondition = lazy(() => import("pages/T&C/TermsAndCondition"))

// knowledge Center
const Circular = lazy(() => import("pages/KnowledgeCenter.js/Circular"))
const Broucher = lazy(() => import("pages/KnowledgeCenter.js/Broucher"))

//Quote
const QuoteHome = lazy(() => import("pages/Quote/Home"));
const CreateQuote = lazy(() => import("pages/Quote/CreateQuote"));

const Comingsoon = lazy(() => import("pages/CommingSoon/index"))
const HomeTs = lazy(() => import("pages/SubscriptionPlan/Home"))
//Financial Planner

//lazy (()=>import())

const ViewFinancialPlanner = lazy(() => import("pages/InsuranceNeed/View"))
const ContactUs = lazy(() => import("pages/ContactUs/Home"))
const UpdateAccess = lazy(() =>
  import("pages/Authentication/Access/UpdateAccess")
)
const CustFiles = lazy(() => import("pages/Customer/FileUploads/CustFiles"))
const PolicyFiles = lazy(() => import("pages/Polices/PolicyFiles"));
const CustUploadFile = lazy(() =>
  import("pages/Customer/FileUploads/CustUploadFile")
)
const NdaAggrement = lazy(() => import("pages/NdaAggrement/NdaAggrement"))

// Commission Statement Consolidation (URL-only, no menu entry)
const CommissionReport = lazy(() => import("pages/CommissionReport"))

const commonRoutes = [
  { path: "/payment/failure", component: <PaymentFailure /> },
  { path: "/payment/success", component: <PaymentSuccess /> },
]

const authProtectedRoutes = [
  // Super Admin Routes Starts
  { path: "/super/admin/dashboard", component: <SuperDashboard /> },
  { path: "/super/admin/employee/:id", component: <SuperAdminEmployees /> },
  { path: "/super/admin/users/plan/:id", component: <SuperAdminUserPlan /> },
  {
    path: "/super/admin/knowledge-center",
    component: <ManageKnowledgeCenter />,
  },
  {
    path: "/super/admin/view/users/subscription",
    component: <SuperAdminViewSubcription />,
  },
  { path: "/super/admin/vehicle-master", component: <VehicleMasterAdmin /> },
  { path: "/super/admin/manage-lob", component: <SuperAdminHome /> },
  { path: "/super/admin/manage-sub-lob", component: <SuperAdminSubLobHome /> },
  {
    path: "/super/admin/insurance-company",
    component: <SuperAdminInsuranceHome />,
  },
  { path: "/super/admin/manage-rto", component: <MangageRTOAdmin /> },
  {
    path: "/super/admin/manage-incomerange",
    component: <ManageIncomerRange />,
  },
  { path: "/super/admin/users/counts/:id", component: <SuperAdminCounts /> },
  { path: "/super/admin/marketing-tools", component: <ManageMarketingTools /> },
  {
    path: "/super/admin/marketing-tools/create-designs",
    component: <CreateDesigns />,
  },
  { path: "/super/admin/nda-agreement", component: <SuperAdminNdaAgreement /> },
  { path: "/super/admin/whatsappmsg", component: <SendWhatsAppMsg /> },
  { path: "/super/admin/query-file", component: <QueryFile /> },

  // Super Admin Routes Ends

  {
    path: "/dashboard",
    component:<Dashboard/>,
  },
  { path: "/reports", component: <DashboardReports /> },
  { path: "/renewal-tracking", component: <RenewalTracking /> },
  { path: "/notifications", component: <Notification /> },
  { path: "/upgrade-plan", component: <HomeUpgradePlan /> },
  { path: "/premium", component: <PremiumPlan /> },

  //profile
  { path: "/profile", component: <UserProfile /> },
  { path: "/social-media", component: <SocialMedia /> },
  { path: "/employee", component: <Employee /> },
  { path: "/employee-profile", component: <EmpProfile /> },
  { path: "/FormWizard", component: <FormWizard /> },
  { path: "/leads", component: <LeadsManagement /> },
  { path: "/customer", component: <CustomerManagement /> },
  { path: "/customer/:id", component: <SingleCustomer /> },
  { path: "/customerfiles/:id", component: <CustFiles /> },
  { path: "/customer-search", component: <SearchCustomer /> },
  { path: "/view-Lead/:id", component: <ViewLeads /> },
  { path: "/view-employee/:id", component: <ViewEmployee /> },
  { path: "/customer-Policy/:id", component: <PolicesDash /> },
  { path: "/customer-mutual-fund/:id", component: <CustomerMutualFund /> },
  { path: "/view-mutual-fund/:id", component: <ViewMutualFund /> },
  { path: "/edit-mutual-fund/:id", component: <EditMutualFund /> },
  { path: "/mutualFund-reports", component: <MutualFundReports /> },
  { path: "/mutual-fund/bulkupload", component: <MutualFundBulkUpload /> },
  { path: "/view-policy/:id", component: <ViewPolicy /> },
  { path: "/policy/bulkupload", component: <PolicyBulkUpload /> },
  { path: "/cross-sell", component: <CrossSellHome /> },
  { path: "/up-sell", component: <UpSellHome /> },
  { path: "/access/:id", component: <Access /> },
  { path: "/addprofile", component: <AddProfile /> },
  { path: "/assignprofile", component: <AssignProfile /> },
  {
    path: "/update-accessprofile/:profileid/:profilename",
    component: <UpdateAccess />,
  },
  { path: "/leads-custom/create", component: <CustomFieldForm /> },
  { path: "/leads-custom/update", component: <CustomFieldForm /> },
  { path: "/blocked-leads-list", component: <BlockedLeads /> },
  { path: "/leads-bulk-upload", component: <LeadsBulkUpload /> },

  { path: "/customer-custom/create", component: <CustomerCustomField /> },
  { path: "/customer-custom/update", component: <CustomerCustomField /> },
  { path: "/customer/bulk-upload", component: <CustBulkUpload /> },
  { path: "/claims", component: <Claim /> },
  { path: "/CalculateInsuranceNeed", component: <CalculateInsuranceNeed /> },

  { path: "/view-financial/:id", component: <ViewFinancialPlanner /> },
  // { path: "/upgrade-plan", component: <HomeUpgradePlan /> },
  { path: "/policy-reports", component: <PolicyReportes /> },
  { path: "/target/:employee_id", component: <Home /> },
  { path: "/target/Dashboard", component: <TargetDash /> },
  { path: "/InsuranceNeedModal", component: <InsuranceNeedModal /> },
  { path: "/policy-reports", component: <PolicyReportes /> },
  { path: "/Create-Design", component: <MarketingTools /> },
  { path: "/select-Design", component: <SelectDesigns /> },
  { path: "/Saved-Design/:designId", component: <SavedDesign /> },

  { path: "/knowledge-circular", component: <Circular /> },
  { path: "/knowledge-brouchers", component: <Broucher /> },

  { path: "/nda-aggrement", component: <NdaAggrement /> },
  { path: "/renewal-trigger", component: <RenewalTrigger /> },
  { path: "/company-knowledge-guide", component: <CompanyKnowledgeGuide /> },
  { path: "/references", component: <References /> },

  { path: "/blocked-customer", component: <BlockedCustomer /> },

  { path: "/reference-files/:id", component: <RefFiles /> },
  { path: "/policyfiles/:id", component: <PolicyFiles /> },

  //Quotes
  { path: "/quotes", component: <QuoteHome /> },
  { path: "/create-quote", component: <CreateQuote />, },

  //Contact us oage
  { path: "/contactus", component: <ContactUs /> },

  { path: "/get-all-policy-reports", component: <ExcelReports /> },

  // Commission Statement Consolidation (reachable by URL only, after login)
  { path: "/commission-report", component: <CommissionReport /> },

  //Legal
  { path: "/terms-of-use", component: <TermsOfUse /> },
  { path: "/cancellation-and-refund", component: <CancellationAndRefund /> },
  { path: "/privacy-policy", component: <PrivacyPolicy /> },

  // this route should be at the end of all other routes
  // eslint-disable-next-line react/display-name
  {
    path: "/",
    exact: true,
    component: <Navigate to="/login" />,
  },
]

const publicRoutes = [
  { path: "/super/admin/login", component: <SLogin /> },
  { path: "/login", component: <Login /> },
  { path: "/logout", component: <Logout /> },
  { path: "/forgot-password", component: <ForgetPwd /> },
  { path: "/register", component: <Register /> },
  { path: "/verify-employee/:phone_no", component: <VerifyEmployee /> },
  { path: "/TermsAndCondition", component: <TermsAndCondition /> },
  { path: "/customer/fileUpload/:hashkey", component: <CustUploadFile /> },
  { path: "/customer/createclaim/:hashkey", component: <CustCreateClaim /> },
]

export { authProtectedRoutes, publicRoutes, commonRoutes }
